import React, { useRef, Children } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
type FeatureListProps = {
  items: string[];
  className?: string;
  variant?: 'default' | 'check' | 'dash';
};
export function FeatureList({
  items,
  className = '',
  variant = 'dash'
}: FeatureListProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const getPrefix = () => {
    switch (variant) {
      case 'check':
        return '✓';
      case 'dash':
        return '→';
      default:
        return '•';
    }
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <motion.ul ref={ref} variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className={`space-y-3 ${className}`} data-id="element-33">
      {items.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-3 text-white group" data-id="element-34">
          <span className="text-matrix-accent font-bold flex-shrink-0 text-xl group-hover:scale-110 transition-transform duration-200" data-id="element-35">
            {getPrefix()}
          </span>
          <span className="text-lg leading-relaxed" data-id="element-36">{item}</span>
        </motion.li>)}
    </motion.ul>;
}